module.exports = __webpack_public_path__ + "img/record-over-btn.dd716bfa.png";